import { TranslationChunksConfig } from "@spartacus/core";
import {
    slbChunks,
    slbCommonChunks,
    slbFooterChunks,
    slbHeaderChunks,
    slbCloudSolutionsPdpChunks,
    slbCartChunks,
    slbEdgeSolutionsPdpChunks,
    slbCheckoutChunks,
    slbServicesSolutionsPdpChunks,
    slbOceanSolutionsPdpChunks,
    SlbOnlinePaymentsChunks
} from "./slb-i18n-models";

export const slbTranslationsChunksConfig: TranslationChunksConfig = {
    [slbChunks.HEADER]: [slbHeaderChunks.ACTIONS],
    [slbChunks.FOOTER]: [slbFooterChunks.FOOTER],
    [slbChunks.CART]: [
        slbCartChunks.CART,
        slbCartChunks.DELFI,
        slbCartChunks.MIXED,
        slbCartChunks.AGORA,
        slbCartChunks.SERVICE,
        slbCartChunks.OCEAN,
        slbCartChunks.NEXT,
        slbCartChunks.SUBSCRIPTION,
        slbCartChunks.NOT_LISTED
    ],
    [slbChunks.COMMON]: [
        slbCommonChunks.DOMAIN, 
        slbCommonChunks.CASE_STUDIES,
        slbCommonChunks.SLB,
        slbCommonChunks.SLB_PDP_DIVIDIED_BANNER,
        slbCommonChunks.ADD_TO_CART_POP_UP,
        slbCommonChunks.FORMS,
        slbCommonChunks.FACET,
        slbCommonChunks.PLUGIN_FACET,
        slbCommonChunks.PAGINATION,
        slbCommonChunks.AUTOCOMPLETE,
        slbCommonChunks.PLATFORM_TYPE
    ],
    [slbChunks.CLOUD_SOLUTIONS_PDP]: [
        slbCloudSolutionsPdpChunks.FORM,
        slbCloudSolutionsPdpChunks.PRODUCT,
        slbCloudSolutionsPdpChunks.CARD,
    ],
    [slbChunks.EDGE_SOLUTIONS_PDP]: [
        slbEdgeSolutionsPdpChunks.EDGE_SOLUTIONS_CARD,
        slbEdgeSolutionsPdpChunks.EDGE_SOLUTIONS_FORM,
        slbEdgeSolutionsPdpChunks.EDGE_SOLUTIONS_PAGE
    ],
    [slbChunks.SERVICES_SOLUTIONS_PDP]: [slbServicesSolutionsPdpChunks.SERVICES_PDP_ADD_TO_CART],
    [slbChunks.CHECKOUT]: [
        slbCheckoutChunks.QUOTE,
        slbCheckoutChunks.SUMMARY,
        slbCheckoutChunks.DELFI_READINESS,
        slbCheckoutChunks.SHIPPING,
        slbCheckoutChunks.PAYMENT,
        slbCheckoutChunks.REVIEW,
        slbCheckoutChunks.STORAGE,
        slbCheckoutChunks.READINESS,
        slbCheckoutChunks.CONFIRMATION,
        slbCheckoutChunks.ORBITAL,
        slbCheckoutChunks.LICENSE,
        slbCheckoutChunks.ORDER
    ],
    [slbChunks.OCEAN_SOLUTIONS_PDP]: [
        slbOceanSolutionsPdpChunks.OCEAN_PDP_PRODUCT
    ],
    [slbChunks.ONLINE_PAYMENTS]: [
        SlbOnlinePaymentsChunks.HISTORY,
        SlbOnlinePaymentsChunks.INVOICE,
        SlbOnlinePaymentsChunks.MAINTENANCE
    ]
}
